import React, { useState } from "react";
import * as XLSX from "xlsx";
import {
    collection,
    getDocs,
    setDoc,
    updateDoc,
    doc,
    query,
    orderBy,
    getDoc,
  } from "firebase/firestore";

  import { db} from "../firebase";
import { toast } from "react-toastify";



const ExcelUploader = () => {
  const [data, setData] = useState([]);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });

      // Assuming you want to read the first sheet
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      // Convert sheet to JSON format
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      // Map the data to the desired format
      const headers = jsonData[0];
      const rows = jsonData.slice(1).map((row) => {
        let rowData = {};
        headers.forEach((header, index) => {
          rowData[header.toLowerCase()] = row[index];
        });
        return rowData;
      });

      setData(rows);
    };

    if (file) {
      reader.readAsBinaryString(file);
    }
  };


  const uploadService = async (serviceData) => {
    try {
      // Create a reference to a new document in the "services" collection
      const newDoc = doc(collection(db, "services"));
  
      // Add the document ID and created_on timestamp to the service data
      serviceData.id = newDoc.id;
      serviceData.created_on = new Date();
      serviceData.thumbnail = "";
      // serviceData.country = "";
      serviceData.images = [];
      serviceData.type = "";
      serviceData.variants = [];
      serviceData.colors = [];
      serviceData.price = String(serviceData.price);
  
      // Upload the data to Firestore
      await setDoc(newDoc, serviceData);
  
      console.log("Document successfully written with ID: ", newDoc.id);

    } catch (error) {
      console.error("Error writing document: ", error);
    }
  };

  const uploadAllServices = async () => {
    if(data.length == 0){
        toast.error("File is Empty");
        return;
    }
    for (const service of data) {
      await uploadService(service);
    }
    toast.success("Services Added Successfully");
    window.location.reload();
  };

  return (
    <div>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
      <div style={{ maxHeight: '300px', overflowY: 'scroll', border: '1px solid #ccc', marginTop: '20px', padding: '10px' }}>
        <div style= {{justifyContent: "space-between", display: "flex"}}>
        <h3>Uploaded Data:</h3>
        <button onClick={uploadAllServices}>Upload Services</button>
        </div>
        <pre>{JSON.stringify(data, null, 2)}</pre>
      </div>
    </div>
  );
};

export default ExcelUploader;
